import { render, staticRenderFns } from "./bodyprint-declined-table.vue?vue&type=template&id=0c8785f9"
import script from "./bodyprint-declined-table.vue?vue&type=script&lang=js"
export * from "./bodyprint-declined-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports